import PropTypes from 'prop-types';

export default PropTypes.shape({
  type: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
});
